// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"ba0306d1","672":"6814f8b8","842":"01821987","977":"8591a78c"}[chunkId] + ".chunk.js";
};